export const EVENTS = {
  sessionStart: 'session_start',
  onboardingStarted: 'onboarding_start',
  onboardingStartedSubmitted: 'onboarding_started_submitted',
  onboardingMassmediaShown: 'onboarding_massmedia_shown',
  onboardingMassmediaSubmitted: 'onboarding_massmedia_submitted',
  onboardingRoleShown: 'onboarding_role_shown',
  onboardingRoleSubmitted: 'onboarding_role_submitted',
  onboardingRoleSkip: 'onboarding_role_skip',
  onboardingLocationsShown: 'onboarding_locations_shown',
  onboardingLocationsSubmitted: 'onboarding_locations_submitted',
  onboardingLocationsSkip: 'onboarding_locations_skip',
  onboardingReasonShown: 'onboarding_reason_shown',
  onboardingReasonSubmitted: 'onboarding_reason_submitted',
  onboardingReasonSkip: 'onboarding_reason_skip',
  onboardingCheckTimeShown: 'onboarding_check_time_shown',
  onboardingCheckTimeSubmitted: 'onboarding_check_time_submitted',
  onboardingCheckTimeSkip: 'onboarding_check_time_skip',
  onboardingUpdatesShown: 'onboarding_updates_shown',
  onboardingUpdatesSubmitted: 'onboarding_updates_submitted',
  onboardingUpdatesSkip: 'onboarding_updates_skip',
  onboardingInappropriateShown: 'onboarding_inappropriate_shown',
  onboardingInappropriateSubmitted: 'onboarding_inappropriate_submitted',
  onboardingInappropriateSkip: 'onboarding_inappropriate_skip',
  onboardingQuantityShown: 'onboarding_quantity_shown',
  onboardingQuantitySubmitted: 'onboarding_quantity_submitted',
  onboardingQuantitySkip: 'onboarding_quantity_skip',
  onboardingFeatureListShown: 'onboarding_feature_list_shown',
  onboardingFeatureListSubmitted: 'onboarding_feature_list_submitted',
  onboardingFeatureListSkip: 'onboarding_feature_list_skip',
  onboardingReceivedAnswersShown: 'onboarding_received_answers_shown',
  onboardingReceivedAnswersSubmitted: 'onboarding_received_answers_submitted',
  onboardingCheckLocation: 'onboarding_check_location',
  onboardingCheckLocationSubmitted: 'onboarding_check_location_submitted',
  onboardingPlacesShown: 'onboarding_places_shown',
  onboardingPlacesSubmitted: 'onboarding_places_submitted',
  onboardingArSearchShown: 'onboarding_ar_search_shown',
  onboardingArSearchSubmitted: 'onboarding_ar_search_submitted',
  onboardingSosShown: 'onboarding_sos_shown',
  onboardingSosSubmitted: 'onboarding_sos_submitted',
  onboardingPlatformsShown: 'onboarding_platforms_shown',
  onboardingPlatformsSubmitted: 'onboarding_platforms_submitted',
  onboardingEnterEmailShown: 'onboarding_enter_email_shown',
  onboardingEnterEmailSubmitted: 'onboarding_enter_email_submitted',
  onboardingQuestionPageSubmitted: 'question_page_completed',
  onboardingFactPageSubmitted: 'fact_page_completed',
  LEAD: 'lead',
  signupSuccess: 'account_created',
  creatingProfileShown: 'creating_profile_shown',
  onboardingPaywallShown: 'onboarding_paywall_shown',
  PAYMENT_SCREEN_LOAD: 'payment_screen_load',
  onboardingPaywallChosen: 'onboarding_paywall_chosen',
  CHECKOUT_SHOWN: 'subs_purchase_show',
  CHECKOUT_SCREEN_LOAD: 'checkout_screen_load',
  onboardingCheckoutShown: 'onboarding_checkout_shown',
  subBuyTapped: 'sub_buy_tapped',
  BUY_SUBSCRIPTION_TAPPED: 'subs_purchase_started',
  SUBSCRIBED: 'subs_purchase_completed',
  PAYMENT_DECLINE: 'subs_purchase_failed',
  subscribed: 'paywall_subscribed',
  subBuyClosed: 'paywall_closed',
  CARD_BRAND_CHOSEN: 'card_checkout_chosen',
  cardMethodChosen: 'card_checkout_chosen',
  PAYMENT_ANIMATION: 'payment_animation_screen',
  paymentAnimationScreen: 'payment_animation_screen',
  onboardingPaymentDecline: 'onboarding_payment_decline',
  onboardingDeclineTryAgain: 'onboarding_decline_try_again',
  DECLINE_TRY_AGAIN: 'payment_declined_try_again',
  upsellView: 'upsell_view',
  upsellTapped: 'upsell_tapped',
  upsellTappedClose: 'upsell_close_tapped',
  upsellPurchased: 'upsell_purchased',
  UPSELL_SUBSCRIBED: 'upsell_purchase_completed',
  SUCCESS_SCREEN_LOAD: 'success_page_show',
  POPUP_EVENT: 'payment_successful_popup',
  upsellFailed: 'upsell_purchased_failed',
  onboardingSuccessShown: 'onboarding_success_shown',
  onboardingDone: 'onboarding_done',
};
